import {AfterViewInit, Directive, DoCheck, ElementRef, HostListener, Input, Renderer2} from '@angular/core';

@Directive({
  selector: '[laInput]'
})
export class LaInputDirective implements AfterViewInit, DoCheck {
  @Input() autoComplete = false;
  @Input() position: string;
  @Input() borderNone: string[] = [];
  @Input() borderRadiusNone: string[] = [];

  constructor(private _el: ElementRef, private _renderer: Renderer2) {
  }

  /*
  * Listing a event when user typing and check control is valid or not
  */
  @HostListener('focusout') onFocusout(): void {
    this._highlightError();
    this._setRefreshEmptyFullStatus();
  }

  ngDoCheck(): void {
    // We need to re-evaluate this on every change detection cycle, because there are some
    // error triggers that we can't subscribe to.
    this._highlightError();
    this._setRefreshEmptyFullStatus();
  }

  ngAfterViewInit(): void {

    // if input has not placeholder, set empty string to placeholder
    const isPlaceholder = this._el.nativeElement.hasAttribute('placeholder');
    if (!isPlaceholder) {
      this._renderer.setAttribute(this._el.nativeElement, 'placeholder', ' ');
    }

    // get placeholder form input and assign to label
    const placeHolder = this._el.nativeElement.getAttribute('placeholder');
    this._renderer.setAttribute(this._el.nativeElement, 'placeholder', ' ');

    this._renderer.addClass(this._el.nativeElement, 'la-text-input-floating');

    if (this.position) {
      this._renderer.addClass(this._el.nativeElement, 'la-text-input-floating--' + this.position.toLowerCase());
    }

    // customize input border
    if (this.borderNone.length > 0) {
      this.borderNone.forEach(border => {
        const className = 'la-text-input-floating--border-' + border.toLowerCase() + '-none';
        this._renderer.addClass(this._el.nativeElement, className);
      })
    }

    // customize input border radius
    if (this.borderRadiusNone.length > 0) {
      this.borderRadiusNone.forEach(border => {
        const className = 'la-text-input-floating--border-radius-' + border.toLowerCase() + '-none';
        this._renderer.addClass(this._el.nativeElement, className);
      })
    }

    if (!this.autoComplete) {
      this._renderer.setAttribute(this._el.nativeElement, 'autocomplete', 'off');
    }

    const parent = this._el.nativeElement.parentNode;

    // Add it inside the div
    this._renderer.appendChild(parent, this._el.nativeElement);

    const label = this._renderer.createElement('label');
    const text = this._renderer.createText(placeHolder);
    this._renderer.appendChild(label, text);
    this._renderer.addClass(label, 'input-place-holder');

    this._renderer.appendChild(parent, label);
    this._setRefreshEmptyFullStatus();
  }

  private _highlightError(): void {
    const classList = this._el.nativeElement.classList;
    if (this._el.nativeElement.offsetParent && this._el.nativeElement.offsetParent != null) {
      if (classList.contains('ng-invalid') && classList.contains('ng-touched')) {
        if (!classList.contains('la-text-input-floating-error')) {
          this._renderer.addClass(this._el.nativeElement, 'la-text-input-floating-error');
        }
      } else if (classList.contains('la-text-input-floating-error')) {
        this._renderer.removeClass(this._el.nativeElement, 'la-text-input-floating-error');
      }
    }
  }

  private _setRefreshEmptyFullStatus(): void {
    if (!!this._el.nativeElement.value) {
      // input has data
      this._renderer.addClass(this._el.nativeElement, 'input-full');
    } else {
      // input is empty
      this._renderer.removeClass(this._el.nativeElement, 'input-full');
    }
  }
}
